// extracted by mini-css-extract-plugin
module.exports = {"brandListWrapper":"ZMNLiJqo7sTFYeJVpvqWz"};